import { ServerData } from '../models';
import { CheckoutBankredirectState } from './state';

export const getInitialState = (
    props?: ServerData,
): CheckoutBankredirectState =>
    props ?? {
        isAppRebrandActive: false,
        isLoading: false,
        payment: null,
        redirectInstructions: null,
    };
